<script setup lang="ts">
const { isAnyBottomSheetOpen } = useBottomSheet()

const startY = ref(0)
const pulling = ref(false)
const loading = ref(false)

const isPWA = () => {
  if (process.server) return false // 서버 사이드에서는 false 반환

  return window.matchMedia('(display-mode: standalone)').matches &&
      /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase())
}

const handleTouchStart = (e: TouchEvent) => {
  if (!isPWA()) return
  if (isAnyBottomSheetOpen.value) return // 바텀시트가 열려있으면 pull-to-refresh 차단
  if (window.scrollY === 0) {
    startY.value = e.touches[0].clientY
    pulling.value = true
  }
}

const handleTouchMove = (e: TouchEvent) => {
  if (!pulling.value) return

  const touch = e.touches[0]
  const pullDistance = touch.clientY - startY.value

  if (pullDistance > 0 && pullDistance < 150) {
    document.body.style.transform = `translateY(${pullDistance}px)`
  }
}

const handleTouchEnd = async () => {
  if (!pulling.value) return

  pulling.value = false
  const pullDistance = parseInt(document.body.style.transform.replace('translateY(', ''))
  document.body.style.transform = ''

  if (pullDistance > 70) {
    loading.value = true
    await new Promise(resolve => setTimeout(resolve, 500))
    window.location.reload()
  }
}

onMounted(() => {
  if (process.client && isPWA()) { // process.client 체크 추가
    document.addEventListener('touchstart', handleTouchStart)
    document.addEventListener('touchmove', handleTouchMove)
    document.addEventListener('touchend', handleTouchEnd)
  }
})

onUnmounted(() => {
  if (process.client && isPWA()) { // process.client 체크 추가
    document.removeEventListener('touchstart', handleTouchStart)
    document.removeEventListener('touchmove', handleTouchMove)
    document.removeEventListener('touchend', handleTouchEnd)
  }
})
</script>


<template>
  <div v-if="isPWA()" class="pull-indicator" :class="{ 'loading': loading }">
    <div v-if="loading" class="spinner"></div>
    <div v-else></div>
  </div>
</template>

<style scoped>
.pull-indicator {
  position: fixed;
  top: env(safe-area-inset-top, 0px);
  left: 0;
  right: 0;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  pointer-events: none;
  z-index: 1000;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-top-color: #333;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
